import styled from 'styled-components';
// import colors from 'styles/colors';

export const COLLAPSIBLE_LIST_CLASSES = {
  EXPANDED: 'collapsible-list--expanded',
  COLLAPSED: 'collapsible-list--collapsed',
};

export const CollapsibleListWrapper = styled.div``;

export const CollapsibleListTitle = styled.div`
  margin-bottom: 0.5em;
`;

export const CollapsibleListIcon = styled.span`
  font-size: 0.5em;
`;

export const CollapsibleListBody = styled.div`
  height: 0;
  overflow: hidden;
  &.${COLLAPSIBLE_LIST_CLASSES.EXPANDED} {
    height: auto;
  }

  & > * {
    padding-left: 1em;
  }
`;
